<template>
  <div
    class="border-b border-gray-20 h-10 w-full flex items-center flex-shrink-0 bg-white"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppTableRow'
}
</script>
